import { FC, ReactNode } from "react"

import { useIsFakeParticipant } from "@/3514/hooks"
import { buildCssClassName } from "@/3514/utils"

import "./styles.scss"

enum EParticipantWrapperSize {
    Small = "sm",
    Medium = "md",
    MaxMedium = "max-md",
    Default = "default"
}

interface IProps {
    size?: EParticipantWrapperSize
    children?: ReactNode
    className?: string
}

const ParticipantWrapper: FC<IProps> = ({
    children,
    size = EParticipantWrapperSize.Small,
    className = String("")
}: IProps) => {
    const isFakeParticipant: boolean = useIsFakeParticipant()

    return (
        <div
            className={buildCssClassName("participant-wrapper", {
                "participant-wrapper-md": size === EParticipantWrapperSize.Medium,
                "participant-wrapper-sm": size === EParticipantWrapperSize.Default,
                "participant-wrapper-max-md": size === EParticipantWrapperSize.MaxMedium,
                "fake-mode": isFakeParticipant,
                [className]: className
            })}
        >
            {children}
        </div>
    )
}

export { EParticipantWrapperSize }

export default ParticipantWrapper
